import React, { useState, useEffect } from 'react';

const NetworkStatus = () => {
    const netNavigator = navigator.connection || navigator.mozConnection || navigator.webkitConnection || navigator.msConnection;
    const [netWork, setNetWork] = useState({ online: navigator?.onLine, networkQuality: netNavigator?.effectiveType === "4g", downlink: netNavigator?.downlink });

    useEffect(() => {
        if (navigator && navigator.connection) {
            navigator.connection.onchange = (ev) => {
                setNetWork({ online: navigator.onLine, networkQuality: ev.currentTarget.effectiveType === "4g", downlink: ev.currentTarget.downlink });
                // if (ev.currentTarget.downlink < 1) {
                //     networkConnectionOffline();
                // }
            };
        }
        window.addEventListener('online', updateOnlineStatus());
        window.addEventListener('offline', updateOnlineStatus());
        // eslint-disable-next-line
    }, []);

    const updateOnlineStatus = () => {
        netWork.online = navigator.onLine;
        setNetWork(netWork);
    }

    const renderNetWork = () => {
        if (netWork.online === true && netWork.networkQuality) {
            return (<i className="mdi mdi-wifi" title="On-line" />);
        } else if (netWork.online && (!netWork.networkQuality || netWork.downlink <= 1)) {
            return (<i className="mdi mdi-wifi-strength-1-alert" title="Connection low" />);
        } else {
            return (<i className="mdi mdi-wifi-off" title="Off-line" />);
        }
    }

    return (renderNetWork());
}

export default NetworkStatus;